import axios from 'axios'
export default {
	namespaced: true,
	state: {
		endpoint: '/currency/type',
		name: 'CurrencyType',
		title: {
			single: 'CurrencyType',
			plural: 'CurrencyTypes'
		},
		icon: 'mdi-format-list-bulleted-type',
		items: [],
	},
	actions: {
		load (context, data) {
			return axios.get(context.getters.endpoint).then(response => {
				//console.log('find','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log('error', error)
			})
		},
	},
}
